/**
 * Calculates appropriate tick interval to avoid overcrowding
 * @param dataLength - The number of data points
 * @returns The interval for showing ticks
 */
export const getTickInterval = (dataLength: number): number => {
  if (dataLength <= 7) return 0; // Show all ticks
  if (dataLength <= 14) return 1; // Show every other tick
  if (dataLength <= 30) return Math.floor(dataLength / 7); // Show ~7 ticks
  return Math.floor(dataLength / 10); // Show ~10 ticks for large datasets
};
